// extracted by mini-css-extract-plugin
module.exports = {"nameContainerPeople":"styles_nameContainerPeople__19Mgy","namePeopleLabel":"styles_namePeopleLabel__3EVnL","nameInputPeople":"styles_nameInputPeople__1TPJX"};